import { Formik } from 'formik'
import { useEffect, useState } from 'react'
import { Col, Form, Modal, Row } from 'react-bootstrap'
import Select from 'react-select'
import Toggle from 'react-toggle'
import api from '../../../../config/AxiosInstance'
import * as Common from '../../../../utils/Common'
import { MapEditorGroundSchema } from '../../../../utils/validationSchema'
import CustomButton from '../../../Button/CustomButton'
function FormUpdateGround(props) {
  const [activeToggle, setActiveToggle] = useState(false)
  const [racks, setRacks] = useState([])
  const [dataRacks, setDataRacks] = useState([])
  const [areas, setAreas] = useState([])
  const [inputRack, setInputRack] = useState('')
  const [inputArea, setInputArea] = useState('')
  const [disableArea, setDisableArea] = useState(true)
  const [detail, setDetail] = useState({})
  useEffect(() => {
    if (props?.warehouseId && props?.show) {
      const controller = new AbortController()
      fetchRacks(props?.warehouseId, controller)
      fetchShowMapData()
      fetchAreas(props?.warehouseId)
      // clean up effect function
      return function () {
        controller.abort()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.warehouseId])
  const fetchShowMapData = async () => {
    try {
      const res = await api.get(
        `/settings/map/editor/slot/${props?.dataShowMap}`
      )
      setDetail(res.data.data)
      setActiveToggle(res.data.data.is_active)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }
  const fetchRacks = async (warehouseId, controller) => {
    try {
      const values = {
        warehouse_id: warehouseId,
        type: 'ground'
      }
      const res = await api.post(`/settings/map/editor/rack/all`, values, {
        signal: controller.signal
      })

      const optionValue = []
      if (res.data.data.length > 0) {
        setDataRacks(res.data.data)
        res.data.data.map((rack) =>
          optionValue.push({
            value: rack.id,
            label: rack.name
          })
        )
      }
      setRacks(optionValue)
    } catch (err) {
      if (err.message !== 'canceled') {
        const errMsg =
          err?.response?.data?.errors?.message || 'An error occurred'

        Common.showPopUpErrorMessage(errMsg)
      }
    }
  }
  const fetchAreas = async (warehouseId) => {
    try {
      const res = await api.post(`settings/map/editor/area/all`, {
        warehouse_id: warehouseId
      })
      const optionValue = []
      if (res.data.data.length > 0) {
        setDisableArea(false)
        res.data.data.map((area) =>
          optionValue.push({
            value: area.id,
            label: area.name
          })
        )
      }
      setAreas(optionValue)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'

      Common.showPopUpErrorMessage(errMsg)
    }
  }
  const handleInputRackChange = (newValue) => {
    setInputRack(newValue)
  }
  const handleSelectRack = (e) => {
    setInputRack(e?.value ?? '')
    if (e) {
      fetchAreas(props.warehouseId)
      setDisableArea(false)
    } else {
      setDisableArea(true)
    }
  }
  const handleInputAreaChange = (newValue) => {
    setInputArea(newValue)
  }
  return (
    <Formik
      initialValues={{
        rack: racks.find((rack) => rack.label === detail.rack_name),
        beam: { value: detail.beam_name, label: detail.beam_name },
        slot: { value: detail.level_name, label: detail.level_name },
        area: areas.find((area) => area.value === detail.area_id),
        type_id: [],
        type: ''
      }}
      enableReinitialize={true}
      validationSchema={MapEditorGroundSchema}
      validateOnChange={true}
      validateOnBlur={true}
      onSubmit={(values) => {
        values.id = detail?.id
        values.activeToggle = activeToggle
        props.handleSubmit(values)
      }}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        errors,
        touched,
        isValid,
        dirty,
        setFieldValue,
        setFieldTouched
      }) => {
        return (
          <Form className="d-grid gap-2" onSubmit={handleSubmit}>
            <Row>
              <Col md={4}>
                <Form.Group>
                  <Form.Label
                    className="text-muted"
                    style={{ fontSize: '13px' }}
                  >
                    RACK
                  </Form.Label>
                  <Select
                    options={
                      inputRack !== ''
                        ? racks.filter(
                            (rack) =>
                              rack.label.toLowerCase() ===
                              inputRack.toLowerCase()
                          )
                        : racks
                    }
                    onBlur={() => {
                      setFieldTouched('rack', true)
                      setFieldTouched('beam', true)
                      setFieldTouched('slot', true)
                    }}
                    onInputChange={handleInputRackChange}
                    onChange={(e) => {
                      setFieldValue('rack', e)
                      handleSelectRack(e)
                      if (!e?.value) {
                        setFieldValue('beam', {})
                        setFieldValue('slot', {})
                        setFieldValue('area', {})
                      } else {
                        const findRack = dataRacks.find(
                          (rack) => rack.id === e?.value
                        )
                        setFieldValue('beam', {
                          value: findRack?.beam_id,
                          label: findRack?.beam_name
                        })
                        setFieldValue('slot', {
                          value: findRack?.slot_id,
                          label: findRack?.slot_name
                        })
                      }
                    }}
                    value={
                      JSON.stringify(values.rack) === '{}' ? null : values.rack
                    }
                    placeholder="Search racks..."
                    isClearable
                    isSearchable
                    isDisabled={true}
                  />
                  {touched.rack && !!errors.rack && (
                    <p className="text-danger mt-2">{errors.rack}</p>
                  )}
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label
                    className="text-muted"
                    style={{ fontSize: '13px' }}
                  >
                    BEAM
                  </Form.Label>
                  <Form.Select
                    aria-label="beam"
                    name="beam"
                    disabled={true}
                    style={{ height: '38px' }}
                  >
                    <option
                      value={
                        JSON.stringify(values.beam) === '{}'
                          ? '-'
                          : values.beam === ''
                            ? '-'
                            : values.beam.value
                      }
                    >
                      {JSON.stringify(values.beam) === '{}'
                        ? '-'
                        : values.beam.label}
                    </option>
                  </Form.Select>
                  {touched.beam && !!errors.beam && (
                    <p className="text-danger mt-2">{errors.beam}</p>
                  )}
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label
                    className="text-muted"
                    style={{ fontSize: '13px' }}
                  >
                    SLOT
                  </Form.Label>
                  <Form.Select
                    aria-label="slot"
                    name="slot"
                    disabled={true}
                    style={{ height: '38px' }}
                  >
                    <option
                      value={
                        JSON.stringify(values.slot) === '{}'
                          ? '-'
                          : values.slot.value
                      }
                    >
                      {JSON.stringify(values.beam) === '{}'
                        ? '-'
                        : values.slot.label}
                    </option>
                  </Form.Select>

                  {touched.slot && !!errors.slot && (
                    <p className="text-danger mt-2">{errors.slot}</p>
                  )}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label
                    className="text-muted"
                    style={{ fontSize: '13px' }}
                  >
                    Area
                  </Form.Label>
                  <Select
                    options={
                      inputArea !== ''
                        ? areas.filter((area) => area.label === inputArea)
                        : areas
                    }
                    onBlur={() => setFieldTouched('area')}
                    onInputChange={handleInputAreaChange}
                    onChange={(e) => {
                      setFieldValue('area', e)
                    }}
                    value={values.area}
                    placeholder="Search areas..."
                    isClearable
                    isSearchable
                    isDisabled={disableArea}
                  />
                  {touched.area && !!errors.area && (
                    <p className="text-danger mt-2">{errors.area}</p>
                  )}
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Label className="text-muted" style={{ fontSize: '13px' }}>
                  Active
                </Form.Label>
                <label className="d-block">
                  <Toggle
                    className="actived"
                    icons={false}
                    onChange={() => setActiveToggle((active) => !active)}
                    checked={activeToggle}
                  />
                </label>
              </Col>
            </Row>
            <Modal.Footer className="mt-3">
              <CustomButton
                text={'Remove'}
                variant={'white'}
                classNameValue={'text-black'}
                onClick={() => props.handleRemoveCoordinateMap(detail?.id)}
              />
              <CustomButton
                onClick={handleSubmit}
                variant={'warning'}
                disabled={!isValid}
                text={'Update'}
              />
            </Modal.Footer>
          </Form>
        )
      }}
    </Formik>
  )
}

export default FormUpdateGround
